import React, { useCallback } from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Tabs as DesignTabs } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import Element from "@whalecloud/page-builder-core/components/Render/components/Element";

const left = css({ textAlign: 'left' });
const { TabPane } = DesignTabs;

const Tabs = props => {
  const { element, nameSpace, ...otherProps } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;

  const { tabs = [], defaultActiveKey, ...restProps } = formItemSettings;
  const contentElements = element.elements.slice(0, tabs.length);

  const defaultKey = defaultActiveKey || contentElements[0].id;

  const renderTitle = useCallback(
    (index: number) => {
      const item = tabs[index];
      return item.text ? item.text : item;
    }, [tabs]
  );

  const eventProps = makeEventProps(element.data.events, nameSpace);
  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-tabs', left)}
            {...formSettings}
          >
            <DesignTabs
              defaultActiveKey={defaultKey}
              {...restProps}
              {...eventProps}
              className={className}
            >
              {
                contentElements.map((child, i) => (
                  <TabPane
                    key={child.id}
                    tab={renderTitle(i)}
                  >
                    <Element element={child} nameSpace={nameSpace} {...otherProps} />
                  </TabPane>
                ))
              }
            </DesignTabs>
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default Tabs;
